import { h } from 'preact';
export const Italic = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("line", { x1: "19", y1: "4", x2: "10", y2: "4" }),
        h("line", { x1: "14", y1: "20", x2: "5", y2: "20" }),
        h("line", { x1: "15", y1: "4", x2: "9", y2: "20" })));
};
//# sourceMappingURL=italic.js.map